import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';
import AboutMeForm from '../../../../Quoters/LongTerm/steps/AboutMeForm';
import AboutData from './AboutData';
import EtradeAboutData from './EtradeAboutData';
import HeroTextData from './HeroTextData';
import EtradeHeroTextData from './EtradeHeroTextData';
import MarketingData from './MarketingData';
import ProductSpecificationsData from './ProductSpecificationsData';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';

export default function LongTermDisabilityData() {
    const [quickQuoteDisclaimer, setQuickQuoteDisclaimer] = useState(null);
    const [primaryBrandColor, setPrimaryBrandColor] = useState(null);
    const [hasQuickQuoteDisclaimer, setHasQuickQuoteDisclaimer] = useState(false);
    const [isEtrade, setIsEtrade] = useState(false);
    const navigate = useNavigate();
    
    const minAge = 18;
    const maxAge = 60;

    useEffect(() => {
        const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
        setQuickQuoteDisclaimer(accountObj.account.quickQuoteDisclaimerHtml);
        setPrimaryBrandColor(accountObj.account.primaryColor);
        if (quickQuoteDisclaimer !== null) {
            setHasQuickQuoteDisclaimer(true);
        } else {
            setHasQuickQuoteDisclaimer(false);
        }
        if (accountObj.account.accountName.toLowerCase() === "etrade") {
            setIsEtrade(true);
        } else {
            setIsEtrade(false)
        }
    }, []);

    return {
        name: "Disability Insurance",
        subtitle: "",
        subtitleExtended: "",
        heroText: (isEtrade) ? EtradeHeroTextData() : HeroTextData(),
        basicInfoForm: () => {
            return <AboutMeForm
                ageSpecs={{ min: 18, max: 60 }}
                onNext={() => {
                    navigate('/quote/disability/long-term');
                }}
                brandTheme={primaryBrandColor}
                showHeader={false}
                submitButtonVariant={'landing'}
            />;
        },
        specs: {
            age: { min: minAge, max: maxAge },
            coverageAmount: { },
        },
        about: isEtrade ? EtradeAboutData() : AboutData(),
        productSpecifications: ProductSpecificationsData(minAge, maxAge),
        marketing: MarketingData(),
        purchasingProcess: PurchasingProcessData(),
        articleKeys: [7, 8, 9],
        articleTitle: "Learn about Disability Insurance",
        faq: FaqData(),
        isAddDefaultFaq: false,
        hideCommonFaq: true,
        footerMessage: "Get disability insurance from start to finish completely online",
        hasQuickQuoteDisclaimer: hasQuickQuoteDisclaimer,
        hideMarketing: isEtrade,
    };
};
